"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockUserInterfaceConfig = exports.mockAllowedModelsConfig = exports.mockAllowedBrandsConfig = exports.mockAllowedProductsConfig = exports.mockInsuredValueConfig = exports.mockCarYearConfig = void 0;
var models_1 = require("../models");
exports.mockCarYearConfig = {
    id: models_1.DynamicRenderConfigId.carYear,
    category: 'old',
    disabled: true,
    maxYear: 0,
    minYear: 0,
    value: 0,
};
exports.mockInsuredValueConfig = {
    id: models_1.DynamicRenderConfigId.insuredValue,
    disabled: false,
    insuredAmount: 0,
};
exports.mockAllowedProductsConfig = {
    id: models_1.DynamicRenderConfigId.allowedProducts,
    allowedProducts: ['foo'],
};
exports.mockAllowedBrandsConfig = {
    id: models_1.DynamicRenderConfigId.allowedBrands,
    brandsId: ['1', '2', '3'],
};
exports.mockAllowedModelsConfig = {
    id: models_1.DynamicRenderConfigId.allowedModels,
    modelsId: ['4', '5', '6'],
};
exports.mockUserInterfaceConfig = {
    id: models_1.DynamicRenderConfigId.userInterface,
    hideBrokerCard: true,
    showSellerCard: true,
};
//# sourceMappingURL=mockDynamicRenderConfig.js.map